import { render, staticRenderFns } from "./SortBtns.vue?vue&type=template&id=7b18e077&"
import script from "./SortBtns.vue?vue&type=script&lang=js&"
export * from "./SortBtns.vue?vue&type=script&lang=js&"
import style0 from "./SortBtns.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports